import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleHeader
} from '../../../components/Collapsible';
import { setCollapseContentTracking } from '../../../store/actions/dataLayer';

import './styles.css';
import { getMessages } from '../../../tppServices/translations/messages';
import { AdDisplayer } from '../../../components/Ads/AdDisplayer/AdDisplayer';

class ServicesByDFP extends PureComponent {
  render() {
    const {
      setCollapseContentTracking,
      intl: { formatMessage: t },
      hideHeader,
      headerPriority,
      services,
      adParams,
      newAdsConfig
    } = this.props;
    const messages = getMessages();
    let classOverride = `details services-collapsible${
      hideHeader ? ' hide-title' : ''
    } `;
    return (
      <CollapsibleContent initialState="open" classOverride={classOverride}>
        <CollapsibleHeader
          onClick={(e, open) => {
            if (open) {
              setCollapseContentTracking('services');
            }
          }}
          priority={headerPriority}
        >
          {t(messages.servicesDetails)}
        </CollapsibleHeader>
        <Collapsible type="no-pad">
          <div className="services">
            {services.map((service, idx) => (
              <AdDisplayer
                newAdsConfig={newAdsConfig}
                adSlot={`service-button-${idx + 1}`}
                key={idx}
                googleAdParams={adParams[`services${service}`]}
              />
            ))}
          </div>
        </Collapsible>
      </CollapsibleContent>
    );
  }
}

ServicesByDFP.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  /** Analytics helper  */
  setCollapseContentTracking: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool,
  headerPriority: PropTypes.number,
  services: PropTypes.arrayOf(PropTypes.string).isRequired,
  adParams: PropTypes.object.isRequired,
  newAdsConfig: PropTypes.object
};
ServicesByDFP.defaultProps = {
  hideHeader: false,
  headerPriority: 0,
  position: 'bottom'
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      setCollapseContentTracking
    },
    dispatch
  )
)(injectIntl(ServicesByDFP));
